import { ChevronLeft } from "lucide-react";
import { OPTIONS, QUESTIONS } from "@/components/wellbeing/who5";

export const Questions = ({ answers, onAnswer, onBack }) => {
  const i = answers.length;
  return (
    <div className="mm-card p-6 sm:p-8 mm-fade-up" key={i} data-testid="wellbeing-question">
      <div className="flex items-center justify-between text-sm text-mm-muted">
        <span data-testid="wellbeing-progress">Question {i + 1} of {QUESTIONS.length}</span>
        {i > 0 && <button onClick={onBack} className="inline-flex items-center gap-1 text-mm-primary font-semibold" data-testid="wellbeing-back"><ChevronLeft size={16} />Back</button>}
      </div>
      <div className="h-1.5 rounded-full bg-mm-primary/10 mt-3 overflow-hidden"><div className="h-full bg-mm-primary transition-[width] duration-500" style={{ width: `${(i / QUESTIONS.length) * 100}%` }} /></div>
      <p className="text-xs uppercase tracking-wider text-mm-muted font-semibold mt-6">Over the last two weeks…</p>
      <h2 className="text-xl sm:text-2xl font-bold mt-2" data-testid="wellbeing-question-text">{QUESTIONS[i]}</h2>
      <div className="grid sm:grid-cols-2 gap-2 mt-6">
        {OPTIONS.map(([v, l]) => (
          <button key={v} onClick={() => onAnswer(v)} className="mm-soft text-left px-4 py-3 rounded-2xl font-medium hover:bg-mm-primary/10 hover:-translate-y-0.5 transition-[background-color,transform]" data-testid={`wellbeing-option-${v}`}>{l}</button>
        ))}
      </div>
    </div>
  );
};
